import { useContent } from "../../../../../contexts/contentContext/contentContext";
import Image from "../../../../Elements/Image/Image";
import Button from "../../../../Elements/Button/Button";
import { memo } from "react";
import { LinkToNewTab } from "../../../../Elements/Link/Link";
import useMediaQueries from "../../../../../hooks/useMediaQueries";

import styles from "./styles.module.scss";
import globalStyles from "../../styles.module.scss";

const ManageTeamSection = memo(() => {
  const { getTextByKey, getHtmlByKey } = useContent();
  const { desktopCondition } = useMediaQueries();

  return (
    <div
      className={`${globalStyles.sectionWrapper} ${styles.manageTeamSectionWrapper}`}
      id="manage-team-title"
    >
      <div className={globalStyles.sectionElement}>
        <h2>{getTextByKey("manage-team-title")}</h2>
        <h3>{getHtmlByKey("manage-team-subtitle")}</h3>
        <p>{getHtmlByKey("manage-team-description")}</p>
        <Image
          name={desktopCondition ? "features/manage_team" : "manage-img-mob"}
          ext="png"
          className={styles.manageTeamScreenshot}
        />
        <p>{getHtmlByKey("manage-team-description-bottom")}</p>
        {/*@ts-ignore*/}
        <LinkToNewTab page="user/profile/account">
          <Button blank className={globalStyles.learnMoreButton}>
            {getTextByKey("learn-more")}
          </Button>
        </LinkToNewTab>
      </div>
    </div>
  );
});

export default ManageTeamSection;
